export default __webpack_public_path__ + "static/media/19.8e9a4565.png";